import { Button, Flex, Image, Text } from "@chakra-ui/core";
import React from "react";
import { Link, useHistory } from "react-router-dom";
import page404 from "../assets/images/404.png";

const Page404 = () => {
  const history = useHistory();
  return (
    <Flex
      w='100%'
      h='100vh'
      d='flex'
      align='center'
      justify='center'
      direction='column'
    >
      <Text
        fontSize='6xl'
        fontWeight='800'
        textAlign='center'
        w='60%'
        lineHeight='none'
      >
        Site under Construction
      </Text>
      <Image src={page404} w='500px' />
      <Flex mt='10'>
        <Button bg='gray.100' color='#000' onClick={() => history.goBack()}>
          Go Back
        </Button>
        <Link to='/'>
          <Button bg='green.300' ml='4'>
            Go Home
          </Button>
        </Link>
      </Flex>
    </Flex>
  );
};

export default Page404;
